import React, { PropsWithChildren } from "react";
import CloseLargeIcon from "../icons/closeIcon/closeLargeIcon";
import colors from "../../../colors";
import { SxProps, Theme, useTheme } from "@mui/material/styles";
import { Box } from "@mui/material";
import { PageHeader } from "../../deals/dealsPageLayout/DealsPageHeader/PageHeader";
import { DealPageActionButtonInfo } from "../../deals/dealsPageLayout/DealsPageHeader/DealsPageHeader";
import Button from "../forms/button";

type RightPanelProps = PropsWithChildren<{
  title: string;
  subTitle?: string;
  isDelimiter?: boolean;
  actionButtons?: DealPageActionButtonInfo[];
  marginTop?: string;
  onClose?: () => void;
}>;

const RightPanel = ({
  onClose,
  title,
  subTitle,
  isDelimiter = true,
  actionButtons = [],
  marginTop = "0px",
  children,
}: RightPanelProps) => {
  const theme = useTheme();

  const outerContainer: SxProps<Theme> = {
    position: "absolute",
    top: 0,
    right: 0,
    height: "100%",
    borderLeft: `20px solid ${theme.palette.tertiary.lighter}`, //this is a hacky way to add a visual break to the divider lines in DealsPageHeader; it would not work well with a dark theme
  };

  const container: SxProps<Theme> = {
    width: "400px",
    boxSizing: "border-box",
    padding: "20px 20px 12px",
    borderLeft: `1px solid ${theme.palette.tertiary.light}`,
    height: "100vh",
    display: "flex",
    backgroundColor: theme.palette.tertiary.lighter,
  };

  const innerContainer: SxProps<Theme> = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    marginTop: marginTop,
  };

  const childrenContainer: SxProps<Theme> = {
    overflowY: "auto",
    display: "flex",
    flex: 1,
  };

  const closeContainer: SxProps<Theme> = {
    width: "28px",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    paddingTop: "4px",
  };

  return (
    <Box sx={outerContainer}>
      <Box sx={container}>
        <Box sx={innerContainer}>
          <Box data-testid="right-panel-title">
            <PageHeader
              title={title}
              subTitle={subTitle}
              showDelimiter={isDelimiter}
              isSidebar={true}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  marginRight: "10px",
                }}
              >
                {actionButtons.map((actionButton, index) => (
                  <Box
                    key={index}
                    sx={{
                      minWidth: "70px",
                    }}
                  >
                    <Button
                      data-testid={actionButton.dataTestId}
                      type={actionButton.primary ? "primary" : "secondary"}
                      size="medium"
                      onClick={() => actionButton.onClick()}
                    >
                      {actionButton.label}
                    </Button>
                  </Box>
                ))}
              </Box>
              {onClose && (
                <Box sx={closeContainer}>
                  <CloseLargeIcon
                    data-testid="close-right-panel"
                    fill={colors.TERTIARY_COLOR_900}
                    onClick={() => onClose()}
                  />
                </Box>
              )}
            </PageHeader>
          </Box>
          <Box sx={childrenContainer}> {children}</Box>
        </Box>
      </Box>
    </Box>
  );
};

export default RightPanel;
